import Phaser from "phaser";
export default class CharacterSelect extends Phaser.Scene {
    constructor() {
        super('character-scene')
    }
    init() {
        this.back = undefined
        this.select = undefined
    }
    preload() {
        this.load.image('Background1', 'images/chara-bg.png')
        this.load.image('Reimu', 'images/Reimu Hakurei.png')
        this.load.image('Back-btn', 'images/back-btn.png')
    }
    create() {
        this.halfWidth = this.scale.width*0.5
        this.halfHeight = this.scale.height*0.5
        this.add.image(this.halfWidth, this.halfHeight, 'Background1').setScale(5)

        this.add.text(280, 100, 'Click to Select Character', {
            fontSize: '50px', fill: '#FFFFFF', fontStyle: 'bold'
        })

        this.select = this.add.image(250, 450, 'Reimu')
        .setScale(10)
        .setInteractive()
        this.select.once('pointerup', () => {
            this.scene.start('hell-bullet-scene')
        })
        this.back = this.add.image(100, 900, 'Back-btn')
        .setScale(3)
        .setInteractive()
        this.back.once('pointerup', () => {
            this.scene.start('home-screen-scene')
        })
    }
}